import*as i from"react";function a(e){if(!e)throw new Error("[helpers.joinWith] A separator must be specified!");return function(t,n,o){const r=i.cloneElement(n,{...n.props,key:o});return t.length?[...t,e,r]:[r]}}export{a as joinWith};
//# sourceMappingURL=join-with.js.map
